import React from 'react';
import './styles/HomePage.css'

function HomePage() {
    return (
        <div className="background-image">
            <h1 className="h1">{process.env.REACT_APP_CONFERENCE_NAME}</h1>
            <h2 className="h2"> Program Schedule</h2>
        </div>
    )
}

export default HomePage
